import React from 'react';
import Card from '../../../../components/Card';
import Button from '../../../../components/Campanhas/Button';

const Thanks = () => (
	<>
		<div className="row justify-content-center">
			<div className="col-lg-10 col-md-12">
				<div className="container">
					<div className="content">
						<Card title="Recebemos a sua solicitação!" classComponent="card-thank">
							Aguarde, que em breve entraremos em contato!
						</Card>
						<Button type="link" height="40px" margin="10px 0px 0px 0px" fontSize="12px" to="./campanhas">IR PARA A HOME</Button>
					</div>
				</div>
			</div>
		</div>
	</>
);

export default Thanks;
